import { useInjection } from "@linkfluence/core/di";
import { notifyError, notifySuccess } from "@linkfluence/core/notifications";
import { UserRepositoryUID } from "@linkfluence/core/user/repositories/UserRepo";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tr } from "@radarly/i18n";
import { DiscoveryPreferencePayload } from "@radarly/models/user";
import { UserRepository } from "../repositories/UserRepository";
import { useCurrentUserLocale } from ".";

interface UpdateParams {
  pid: number;
  workspaceId: number;
  params: DiscoveryPreferencePayload;
}
export function useUpdateCurrentUserDiscoveryPreferences() {
  const repository = useInjection<UserRepository>(UserRepositoryUID);

  const locale = useCurrentUserLocale();
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError } = useMutation(
    ({ pid, workspaceId, params }: UpdateParams) => {
      return repository.updateDiscoveryPreferences(pid, workspaceId, params);
    },
    {
      onSuccess: async (pref, { pid, workspaceId }) => {
        notifySuccess(tr(locale, "DISCOVERY::PREFERENCES_UPDATE::SUCCESS"));
        queryClient.invalidateQueries(["/user/getDiscoveryPreferences"]);
        queryClient.invalidateQueries(["/insight-page/getDiscovery"]);
        queryClient.setQueryData(
          ["/user/getDiscoveryPreferences", { pid, workspaceId }],
          pref
        );
      },
      onError: () => {
        notifyError(tr(locale, "DISCOVERY::PREFERENCES_UPDATE::ERROR"));
      },
    }
  );
  const updatePreferences = (data: {
    pid: number;
    workspaceId: number;
    params: DiscoveryPreferencePayload;
  }) => {
    return mutateAsync(data);
  };
  return {
    loading: isLoading,
    updatePreferences,
    error: isError,
  };
}
